/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Fragment, useEffect, useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import axiosInstance from "./../../helpers/axiosInstance"
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media,
  Button,
  NavLink
} from "reactstrap";
import SeguridadIcon from "../../assets/img/icons/Icon-Seguridad-Gris.png";
import SalidaIcon from "../../assets/img/icons/Icon-Salida-Gris.png";
import SeguridadIconVerde from "../../assets/img/icons/Icon-Seguridad-Verde.png";
import SalidaIconVerde from "../../assets/img/icons/Icon-Salida-Verde.png";
import ContactosGris from "../../assets/img/icons/Icon-Contactos-Gris.png";
import ContactosVerde from "../../assets/img/icons/Icon-Contactos-Verde.png";
import { useSelector,useDispatch } from "react-redux";
import {desactivasidebar, opcadmnav} from "../../Slicersreducers";
import basePerfiles from "../../views/siif/basePerfiles.js";
const _=require("lodash");
const AdminNavbar = (props) => {
  const [estadoiconos,setestadoiconos]=useState([SeguridadIcon,SalidaIcon,ContactosGris]);
  const [perfiles, setperfiles] = useState(basePerfiles);
  const [permisos,setpermisos]=useState([{name:"Contactos",
                                          habil:false}]);                                            
  const dispatch=useDispatch();

  useEffect(()=>{
    const perfilCookie=getCookie("TEMPORAL");
    console.log("cookie temporal " + perfilCookie);
    let permitido=false;
    if (perfilCookie){
      for(let i=0;i<perfiles.length;i++){
        if(perfiles[i].nombrePerfil=="Contactos"){
          if(perfilCookie.length>i){
            if(perfilCookie.substring(i,i+1)=="1"){
              console.log("Perfil habilitado TM");
              permitido=true;
            }else{
              console.log("perfil inhabilitado TM");
              permitido=false;
            }
          }
          i=perfiles.length;
        }
      }
    }else{
      console.log("no se encuetra cookie");
      permitido=false;
    }
    if(permitido){
      let copiapermisos=_.cloneDeep(permisos);
      for(let i=0;i<copiapermisos.length;i++){
        if(copiapermisos[i].name=="Contactos"){
          copiapermisos[i].habil=true;
          i=copiapermisos.length;
        }
      }
      setpermisos(_.cloneDeep(copiapermisos));
    }
  },[]);

  const miga=useSelector((state)=>state.miga.value);
  console.log("miga en el adminbarr");
  console.log(miga);

  const opcnav=useSelector((state)=>state.miga.opcnav);

  const cambiaiconoact=(activo,index)=>{
    console.log("index " + index + " estado " + activo)
    let copiaiconos=[...estadoiconos];
    if(activo){
      switch(index){
        case 0:
          copiaiconos[0]=SeguridadIconVerde;

        break;
        case 1:
          copiaiconos[1]=SalidaIconVerde;

        break;
        case 2:
          copiaiconos[2]=ContactosVerde;
        break;
      }

    }else{
      switch(index){
        case 0:
          copiaiconos[0]=SeguridadIcon;
          

        break;
        case 1:
          copiaiconos[1]=SalidaIcon;

        break;
        case 2:
          copiaiconos[2]=ContactosGris;
        break;
      }

    }
    setestadoiconos([...copiaiconos]);
  }

  const getCookie = (name) => {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  const logOut = async () => {

    const user = {
      IDType: parseInt(getCookie("tid")),
      NID: parseInt(getCookie("nid")),
      Longitude: "-122.40641",
      Latitud: "37.785834"
    }
    const request = await axiosInstance().post("/WSGYG39_2/api/Users/Logout", user)
      .catch(err => {
        return 'err';
      });
    if (request != 'err') {
      window.location = "/BancaVirtual/";
      console.log(request.data);
    }
    return request;
  }
  
  let mostraropc=false;
    
  //console.log(permisos)
  for(let i=0;i<permisos.length;i++){
    if(permisos[i].name=="Contactos"){
      if(permisos[i].habil){
        mostraropc=true;
        i=permisos.length;
      }
    }
  }
  const reduxopcselec=(opc)=>{
    dispatch(opcadmnav(opc));
  }
  const reduxinicioselec=()=>{
    dispatch(desactivasidebar());
  }
  if(mostraropc){

    return (
      <>
        <Navbar className="navbar-top navbar-dark bg-white" style={{padding:"0px 0px 0px 0px"}} expand="md" id="navbar-main">
          <Container fluid style={{height:"84px"}}>
            <Link
              className="h5 mb-0 text-green d-none d-lg-inline-block"
              to="/admin/home"
              onClick={()=>{reduxinicioselec()}}
            >
              {//props.brandText
              }
              {miga}
            </Link>
            <Nav className="align-items-center d-none d-md-flex" style={{height:"100%"}} navbar>
               <NavLink
                to="/admin/contacts"
                tag={NavLinkRRD}
                activeClassName=""
                className="itemactivo"
                onClick={()=>{reduxopcselec("contactos")}}
              >
                <button onMouseOver={()=>{cambiaiconoact(true,2)}} onMouseOut={()=>{cambiaiconoact(false,2)}} className={opcnav=="contactos" ? "botonnavbarselec" : "botonnavbarsuperioractivo"} style={{display:"flex",flexDirection:"row"}}>
                  <span className="btn-inner--icon">                
                  <i> <img style={{height:"20px"}} src={opcnav=="contactos" ? ContactosVerde : estadoiconos[2]}></img></i> 
                  </span>
                  <span className="btn-inner--text mt-2">Contactos</span>
                </button>
              </NavLink>
                {/*
                <NavLink
                  to="/admin/certificates"
                  tag={NavLinkRRD}
                  activeClassName="active"
                >
                  <button className="btn-icon text-primary btn">
                    <span className="btn-inner--icon">
                      <i className="far fa-file-alt" />
                    </span>
                    <span className="btn-inner--text">Extractos y certificados</span>
                  </button>
                </NavLink>})
              }
            /* <NavLink
                to="/admin/contacts"
                tag={NavLinkRRD}
                activeClassName="active"
              >
                <button className="btn-icon text-grissantander btn">
                  <span className="btn-inner--icon">                
                  <i> <img style={{height:"20px", }} src={require("../../assets/img/icons/Icon-Contactos-Gris.png").default}></img></i> 
                  </span>
                  <span className="btn-inner--text">Contactos</span>
                </button>
                </NavLink>
              {/*
              <NavLink
                to="/admin/certificates"
                tag={NavLinkRRD}
                activeClassName="active"
              >
                <button className="btn-icon text-primary btn">
                  <span className="btn-inner--icon">
                    <i className="far fa-file-alt" />
                  </span>
                  <span className="btn-inner--text">Extractos y certificados</span>
                </button>
              </NavLink>
              */}
              {/* <NavLink
                to="/admin/security"
                tag={NavLinkRRD}
                activeClassName=""
                className="itemactivo"
                onClick={()=>{reduxopcselec("seguridad")}}
              >
                <button onMouseOver={()=>{cambiaiconoact(true,0)}} onMouseOut={()=>{cambiaiconoact(false,0)}} className={opcnav=="seguridad" ? "botonnavbarselec" : "botonnavbarsuperioractivo"} style={{display:"flex",flexDirection:"row"}}>
                  <span className="btn-inner--icon">
                    
                    <i> <img style={{height:"20px", }} src={opcnav=="seguridad" ? SeguridadIconVerde : estadoiconos[0]}></img></i> 
                  </span>
                  <span className="btn-inner--text mt-2" >Seguridad</span>
                </button>
              </NavLink> */}
              <button className="botonnavbarsuperioractivo" onClick={() => logOut()} onMouseOver={()=>{cambiaiconoact(true,1)}} onMouseOut={()=>{cambiaiconoact(false,1)}}>
                <span className="btn-inner--icon">
                  {/*<i className="fas fa-sign-out-alt" />*/}
                  <i> <img style={{height:"20px", }} src={estadoiconos[1]}></img></i> 
                </span>
                <span className="btn-inner--text mt-2">Salida Segura</span>
              </button>
            </Nav>
          </Container>
        </Navbar>
      </>
    );
  }else{
    return (
      <>
        <Navbar className="navbar-top navbar-dark bg-white" style={{padding:"0px 0px 0px 0px"}} expand="md" id="navbar-main">
          <Container fluid style={{height:"84px"}}>
            <Link
              className="h5 mb-0 text-green d-none d-lg-inline-block"
              to="/admin/home"
            >
              {//props.brandText
              }
              {miga}
            </Link>
            <Nav className="align-items-center d-none d-md-flex" style={{height:"100%"}} navbar>
                {/*
                <NavLink
                  to="/admin/certificates"
                  tag={NavLinkRRD}
                  activeClassName="active"
                >
                  <button className="btn-icon text-primary btn">
                    <span className="btn-inner--icon">
                      <i className="far fa-file-alt" />
                    </span>
                    <span className="btn-inner--text">Extractos y certificados</span>
                  </button>
                </NavLink>})
              }
            /* <NavLink
                to="/admin/contacts"
                tag={NavLinkRRD}
                activeClassName="active"
              >
                <button className="btn-icon text-grissantander btn">
                  <span className="btn-inner--icon">                
                  <i> <img style={{height:"20px", }} src={require("../../assets/img/icons/Icon-Contactos-Gris.png").default}></img></i> 
                  </span>
                  <span className="btn-inner--text">Contactos</span>
                </button>
                </NavLink>*/}
              {/*
              <NavLink
                to="/admin/certificates"
                tag={NavLinkRRD}
                activeClassName="active"
              >
                <button className="btn-icon text-primary btn">
                  <span className="btn-inner--icon">
                    <i className="far fa-file-alt" />
                  </span>
                  <span className="btn-inner--text">Extractos y certificados</span>
                </button>
              </NavLink>
              */}
              {/* <NavLink
                to="/admin/security"
                tag={NavLinkRRD}
                activeClassName=""
                className="itemactivo"
                onClick={()=>{reduxopcselec("seguridad")}}
              >
                <button className={opcnav=="seguridad" ? "botonnavbarselec" : "botonnavbarsuperioractivo"} onMouseOver={()=>{cambiaiconoact(true,0)}} onMouseOut={()=>{cambiaiconoact(false,0)}}>
                  <span className="btn-inner--icon">
                 
                    <i> <img style={{height:"20px", }} src={opcnav=="seguridad" ? SeguridadIconVerde : estadoiconos[0]}></img></i> 
                  </span>
                  <span className="btn-inner--text" >Seguridad</span>
                </button>
              </NavLink> */}
              <button className="botonnavbarsuperioractivo" onClick={() => logOut()} onMouseOver={()=>{cambiaiconoact(true,1)}} onMouseOut={()=>{cambiaiconoact(false,1)}}>
                <span className="btn-inner--icon">
                  {/*<i className="fas fa-sign-out-alt" />*/}
                  <i> <img style={{height:"20px", }} src={estadoiconos[1]}></img></i> 
                </span>
                <span className="btn-inner--text">Salida Segura</span>
              </button>
            </Nav>
          </Container>
        </Navbar>
      </>
    )

  }
};

export default AdminNavbar;
